export const DEBUG_PAYWALL_MODAL_KEY = 'debugPaywall';
